import { useState } from "react";

function AuditFilters({ logs, setFilteredLogs }) {
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);

    const filtered = logs.filter((log) =>
      JSON.stringify(log).toLowerCase().includes(value.toLowerCase())
    );

    setFilteredLogs(filtered);
  };

  return (
    <div className="flex flex-col md:flex-row gap-3 mb-4">

      <input
        type="text"
        placeholder="Search audit logs..."
        className="border rounded px-3 py-2 w-full md:w-1/3"
        value={search}
        onChange={(e) => handleSearch(e.target.value)}
      />

    </div>
  );
}

export default AuditFilters;